import ValidationMessageList from '../../../../validation/component/ValidationMessageList'
import React from 'react'

const getCustomErrorValidationObject = (text) => {
    return {
        messageId: text,
        message: text,
    }
}

const getMissingColumnsValidationObject = (missingColumnsText) => {
    return {
        messageId: 'missing_columns',
        message: `Columns are missing: ${missingColumnsText}`,
    }
}

const getMissingValuesText = (missingValues) => {
    return `Missing values (${missingValues})`
}

const getUnknownValuesText = (unknownValues) => {
    return `Not valid data (${unknownValues})`
}

const getMissingAndUnknownValuesValidationObject = (key, error) => {
    const rowNumber = key.replace('entry_num', '')

    const rowText = `Row #${rowNumber}: `
    const errorText = []

    if (error[key]['missingValues']) {
        const missingValues = error[key]['missingValues'].join(', ')
        errorText.push(getMissingValuesText(missingValues))
    }

    if (error[key]['unknownValues']) {
        const unknownValues = error[key]['unknownValues'].join(', ')
        errorText.push(getUnknownValuesText(unknownValues))
    }

    return {
        messageId: key,
        message: rowText + errorText.join(', '),
    }
}

const getUnknownCombinationValidationObject = (key) => {
    const rowNumber = key.replace('entry_num', '')

    return {
        messageId: key,
        message: `Row #${rowNumber}: Unknown combination of manufacturer, thickness and type`,
    }
}

const buildValidationMessageList = (error) => {
    const validationMessageList = []

    if (error.error) {
        validationMessageList.push(getCustomErrorValidationObject(error.error))
        return validationMessageList
    }

    if (error.missing_columns) {
        validationMessageList.push(getMissingColumnsValidationObject(error.missing_columns.join(', ')))
        return validationMessageList
    }

    if (error.duplicates) {
        error.duplicates.forEach((entry) => {
            validationMessageList.push(getCustomErrorValidationObject(entry))
        })
        return validationMessageList
    }

    Object.keys(error).forEach((key) => {
        if (error[key]['missingValues'] || error[key]['unknownValues']) {
            const validationObject = getMissingAndUnknownValuesValidationObject(key, error)
            validationMessageList.push(validationObject)
        }
    })
    if (validationMessageList.length > 0) {
        return validationMessageList
    }

    Object.keys(error).forEach((key) => {
        if (error[key]['unknownCombination']) {
            const validationObject = getUnknownCombinationValidationObject(key)
            validationMessageList.push(validationObject)
        }
    })
    return validationMessageList
}

const Validation = ({ error }) => {
    if (!error) return null

    return (
        <ValidationMessageList
            validationMessageList={buildValidationMessageList(error)}
        />
    )
}

export default Validation



// WEBPACK FOOTER //
// ./src/modules/foil/component/overview/csv-upload/UploadValidation.js